import { GameConfig } from "@/config/GameConfig";

/** Bumped only if the "CHOOSE YOUR BITE" intro's content changes in a way analysis needs to know about - stamped onto `tutorial_completed` (see `src/analytics`). Independent of `GameConfig.storage.tutorialSeenKey` itself, which never changes. */
export const TUTORIAL_VERSION = 1;

/**
 * Tracks whether the player has seen the one-time "CHOOSE YOUR BITE"
 * intro modal. Deliberately a separate key from campaign progress - it's
 * not gameplay state, and clearing it should never be able to affect
 * unlocked levels, scores or stars.
 */
export const TutorialStorage = {
  hasSeenIntro(): boolean {
    try {
      return globalThis.localStorage?.getItem(GameConfig.storage.tutorialSeenKey) === "1";
    } catch {
      return false;
    }
  },

  markIntroSeen(): void {
    try {
      globalThis.localStorage?.setItem(GameConfig.storage.tutorialSeenKey, "1");
    } catch {
      // Ignore storage failures - the intro will just show again next time.
    }
  },
};
